import { render, staticRenderFns } from "./OrganizationRealName.vue?vue&type=template&id=43a39e56&scoped=true&"
import script from "./OrganizationRealName.vue?vue&type=script&lang=js&"
export * from "./OrganizationRealName.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationRealName.vue?vue&type=style&index=0&id=43a39e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a39e56",
  null
  
)

export default component.exports